<template>
    <console-layout width="100%" max-width="1024">

        <console-title>
            <span>회원 통계</span>
        </console-title>

        <console-body>
            <v-card class="mt-4 mx-1">
                <v-card-title class="subtitle-2 font-weight-bold">일간 방문자수</v-card-title>
                <v-chart :data="historyDailyStatistics.count" :x-axis-data="historyDailyStatistics.xAxisData"/>
            </v-card>
    
            <v-card class="mt-4 mx-1">
                <v-card-title class="subtitle-2 font-weight-bold">연간 가입자수</v-card-title>
                <v-chart :data="yearlyStatistics.count" :x-axis-data="yearlyStatistics.xAxisData" />
            </v-card>
            <v-card class="mt-4 mx-1">
                <v-card-title class="subtitle-2 font-weight-bold">월간 가입자수</v-card-title>
                <v-chart :data="monthlyStatistics.count" :x-axis-data="monthlyStatistics.xAxisData" />
            </v-card>
            <v-card class="mt-4 mx-1">
                <v-card-title class="subtitle-2 font-weight-bold">일간 가입자수</v-card-title>
                <v-chart :data="dailyStatistics.count" :x-axis-data="dailyStatistics.xAxisData" />
            </v-card>
    
            <v-card class="mt-4 mx-1">
                <v-card-title class="subtitle-2 font-weight-bold">지역별 회원수</v-card-title>
                <v-card-text>
                    <v-graph :data="areasStatistics.count" :x-axis-data="areasStatistics.xAxisData" />
                </v-card-text>
            </v-card>
    
            <v-card class="mt-4 mx-1">
                <v-card-title class="subtitle-2 font-weight-bold">등급별 회원수</v-card-title>
                <v-card-text>
                    <v-graph :data="levelsStatistics.count" :x-axis-data="levelsStatistics.xAxisData" />
                </v-card-text>
            </v-card>
        </console-body>

    </console-layout>
</template>

<script>
import api from "@/api";
import NaverSmarteditor from "@/components/plugins/naver/naver-smarteditor.vue";
import VChart from "@/components/console/statistic/v-chart.vue";
import VGraph from "@/components/console/statistic/v-graph.vue";

export default {
    components: {
        NaverSmarteditor,
        VChart,
        VGraph
    },
    data(){
        return {
            statistic: null
        }
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let statistic = await api.console.member.statistic.get();
            console.log({statistic})
            this.statistic = statistic;
        },
    },

    computed: {
        dailyStatistics(){
            let statistics = this.statistic?.dateStatistic.reduce((statistics, statistic) => {
                return [...statistics, ...statistic.month.reduce((statistics, statistic) => {
                    return [...statistics, ...statistic.day]
                },[])]
            }, []) || [];
            let xAxisData = statistics.map(statistic => statistic.ymd) || [];
            let count = statistics.map(statistic => statistic.count) || [];

            return {
                xAxisData,
                count
            }
        },
        monthlyStatistics(){
            let statistics = this.statistic?.dateStatistic.reduce((statistics, statistic) => {
                return [...statistics, ...statistic.month]
            }, []) || [];
            let xAxisData = statistics.map(statistic => statistic.ym) || [];
            let count = statistics.map(statistic => statistic.count) || [];

            return {
                xAxisData,
                count
            }
        },
        yearlyStatistics(){
            let statistics = this.statistic?.dateStatistic || [];
            let xAxisData = statistics.map(statistic => statistic.year) || [];
            let count = statistics.map(statistic => statistic.count) || [];

            return {
                xAxisData,
                count
            }
        },
        areasStatistics(){
            let statistics = this.statistic?.areaStatistic || [];

            delete statistics._id;

            let xAxisData = Object.keys(statistics) || [];
            let count = Object.values(statistics) || [];

            return {
                xAxisData,
                count
            }
        },
        levelsStatistics(){
            let statistics = this.statistic?.levelStatistic || [];

            delete statistics._id;

            let xAxisData = Object.keys(statistics) || [];
            let count = Object.values(statistics) || [];

            return {
                xAxisData,
                count
            }
        },
        historyDailyStatistics(){
            let statistics = this.statistic?.historyDateStatistic.reduce((statistics, statistic) => {
                return [...statistics, ...statistic.month.reduce((statistics, statistic) => {
                    return [...statistics, ...statistic.day]
                },[])]
            }, []) || [];
            let xAxisData = statistics.map(statistic => statistic.ymd) || [];
            let count = statistics.map(statistic => statistic.count) || [];
            return {
                xAxisData,
                count
            }
        },
    }
}
</script>